import { render, staticRenderFns } from "./GeneralSearchResultsExtensionBased_PreviousWorking.vue?vue&type=template&id=6827e2ac&"
import script from "./GeneralSearchResultsExtensionBased_PreviousWorking.vue?vue&type=script&lang=js&"
export * from "./GeneralSearchResultsExtensionBased_PreviousWorking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports